module.exports = __webpack_public_path__ + "img/double-check.5e397961.svg";